/**
 * 小程序配置文件
 */
import store from '../store'
store.commit('SET_THEME', 'dbfit')
const theme = store.state.app.theme
document.body.setAttribute('data-theme', 'dbfit')
var config:any = {

}
if (theme === 'ecefit') {
  config.navlogo = 'https://oss.zhihanyun.com/organize-navlogo-ecefit.png'
} else if (theme === 'dbfit') {
  config.navlogo = 'https://oss.zhihanyun.com/organize-navlogo-dbfit.png'
}

export default {
  config
}
